import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * PARA API base URLs: same host as GT with `/gt` stripped from {@link environment.apiUrl}.
 */
@Injectable({ providedIn: 'root' })
export class ParaApiRootService {
	private readonly apiOrigin: string;

	constructor() {
		this.apiOrigin = (environment.apiUrl || '').replace(/\/gt\/?$/i, '');
	}

	/** API host without the `/gt` suffix (used for PARA and classic participant routes). */
	get origin(): string {
		return this.apiOrigin;
	}

	/**
	 * Full URL under a PARA controller base: `/para/{controllerId}/{path}`.
	 * Example: `paraUrl('reports', 'getProgressReport/nodeId/123')`.
	 */
	paraUrl(controllerId: string, pathWithinController: string): string {
		const c = String(controllerId || '')
			.replace(/^\//, '')
			.replace(/\/$/, '');
		const p = String(pathWithinController || '').replace(/^\//, '');
		return `${this.apiOrigin}/para/${c}/${p}`;
	}

	rosterUrl(path: string): string {
		return this.paraUrl('roster', path);
	}
	reportsUrl(path: string): string {
		return this.paraUrl('reports', path);
	}
	assessmentUrl(path: string): string {
		return this.paraUrl('assessment', path);
	}
	chartsUrl(path: string): string {
		return this.paraUrl('charts', path);
	}
	treeUrl(path: string): string {
		return this.paraUrl('tree', path);
	}

	/**
	 * Back-compat convenience for the legacy `/para/progress/...` controller.
	 * Prefer `paraUrl()` for newer controllers.
	 */
	progressUrl(pathWithinProgress: string): string {
		return this.paraUrl('progress', pathWithinProgress);
	}
}
